<div fxLayout="column" fxLayoutGap="15px">
  <div fxLayout="row">
    <h2 *ngIf="!affiliateCodeObject">Dodaj</h2>
    <h2 *ngIf="affiliateCodeObject">Edytuj</h2>
  </div>


  <div
    fxLayout="row"
    fxLayout.lt-md="column"
    fxFlex="100"
    fxLayoutAlign="start center"
    fxLayoutAlign.lt-md="start start"
    fxLayoutGap="10px"
  >
    <mat-label
      style="white-space: nowrap; display: flex; align-items: center;"
    >
      Generuj kod:
    </mat-label>

    <mat-radio-group
      [(ngModel)]="individualCodeProvide"
      class="custom-radio-group"
      fxLayout="row"
      fxLayout.lt-md="column"
      style="display: flex; align-items: center;"
    >
      <mat-radio-button [value]="false">Automatycznie</mat-radio-button>
      <mat-radio-button [value]="true">Ręcznie</mat-radio-button>
    </mat-radio-group>
  </div>




  <div fxLayout="row" *ngIf="individualCodeProvide === true">
    <mat-form-field fxFlex="100">
      <mat-label>Kod zniżkowy</mat-label>
      <input appCapitalizeFirst matInput placeholder="Wprowadź kod zniżkowy" [formControl]="individualCodeControl">
      <mat-error *ngIf="individualCodeControl.hasError('required')">
        Kod zniżkowy jest wymagany
      </mat-error>
      <mat-error *ngIf="individualCodeControl.hasError('pattern')">
        Kod może zawierać tylko litery i cyfry
      </mat-error>
      <mat-error *ngIf="individualCodeControl.hasError('minlength')">
        Kod musi mieć co najmniej {{individualCodeControl.getError('minlength').requiredLength}} znaków
      </mat-error>
      <mat-error *ngIf="individualCodeControl.hasError('maxlength')">
        Kod nie może mieć więcej niż {{individualCodeControl.getError('maxlength').requiredLength}} znaków
      </mat-error>
    </mat-form-field>
  </div>

  <div fxLayout="row">
    <mat-form-field fxFlex="100">
      <mat-label>Opis kodu</mat-label>
      <input appCapitalizeFirst matInput placeholder="Opis" [formControl]="nameControl" [required]="false">
    </mat-form-field>
  </div>
  <div fxLayout="row" *ngIf="!ofwcaObject && !affiliateCodeObject ">
    <app-dict-ofwcas fxFlex="100" label="OFWCA"
                     [control]="ofwcaControl"
                     [required]="true"
                     [ofwcaItems]="partnerOfwca">
    </app-dict-ofwcas>
  </div>
  <div fxLayout="row">
     <h2 >Dane kontaktowe opiekuna polis</h2>
  </div>
  <div fxLayout="row">
    <mat-form-field fxFlex="100">
      <mat-label>Imię</mat-label>
      <input appCapitalizeFirst matInput placeholder="Imię " [formControl]="firstNameControl" [required]="true">
    </mat-form-field>
  </div>

  <div fxLayout="row">
    <mat-form-field fxFlex="100">
      <mat-label>Nazwisko</mat-label>
      <input appCapitalizeFirst matInput placeholder="Nazwisko " [formControl]="lastNameControl" [required]="true">
    </mat-form-field>
  </div>

  <div fxLayout="row">
    <mat-form-field fxFlex="100">
      <mat-label>Adres email</mat-label>
      <input  matInput placeholder="Adres email " [formControl]="emailControl" [required]="true">
    </mat-form-field>
  </div>

  <div fxLayout="row">
    <mat-form-field fxFlex="100">
      <mat-label>Numer telefonu</mat-label>
      <input appCapitalizeFirst matInput placeholder="+48 500 200 300" [formControl]="phoneControl" [required]="true" prefix="+48" mask=" 000 000 000">
    </mat-form-field>
  </div>

  <div fxLayout="row" *ngIf="affiliateCodeObject" >
    <mat-slide-toggle fxFlex="100" color="accent" [formControl]="mainControl">Kod główny</mat-slide-toggle>
  </div>


  <div fxLayout="row" fxLayoutGap="15px">
    <span fxFlex></span>

    <button
      mat-raised-button (click)="sendForm()" color="primary"
      [class.spinner]="processingRequest" [disabled]="processingRequest || !enableSaveButton"
    >Zapisz</button>
    <button (click)="closeDialog($event)" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
